import React from "react";
import AccomodationPriceDetail from "./AccomodationPriceDetail";

export default function AccomodationPrice({ contract, contractPriceDetails, productName }) {
  return contractPriceDetails.map((cpd, index) => <AccomodationPriceDetail index={index} contract={contract} cpd={cpd} key={cpd.id} />);
}
